import React, { createContext, useReducer, useMemo } from 'react';
import PropTypes from 'prop-types';

import reducer from './Reducer';
import actions from './Actions';

const initialState = {
  enterpriseId: null,
  finchOptions: {},
  members: null,
  fileName: null,
};

const context = createContext();

export function ContextProvider({ enterpriseId, finchOptions, children }) {
  initialState.enterpriseId = enterpriseId;
  initialState.finchOptions = finchOptions;
  const [state, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => ({
    state, dispatch, actions,
  }), [state, dispatch, actions]);

  return (
    <context.Provider value={value}>
      {children}
    </context.Provider>
  );
}

ContextProvider.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  finchOptions: PropTypes.object,
  children: PropTypes.element.isRequired,
};

ContextProvider.defaultProps = {
  finchOptions: {},
};

export const useContext = () => React.useContext(context);
